import { DECK_GRID_COLS, DECK_GRID_ROWS, type DeckTile } from "@livcg/schema";

export function tilesCollide(a: DeckTile, b: DeckTile): boolean {
  return a.x < b.x + b.w && b.x < a.x + a.w && a.y < b.y + b.h && b.y < a.y + a.h;
}

/** Whether the candidate's spot is valid: within bounds and not intersecting
 *  tiles (other than itself). No push/reflow — false if invalid. */
export function placementValid(tiles: DeckTile[], candidate: DeckTile): boolean {
  if (candidate.x < 0 || candidate.y < 0) return false;
  if (candidate.x + candidate.w > DECK_GRID_COLS) return false;
  if (candidate.y + candidate.h > DECK_GRID_ROWS) return false;
  return tiles.every((t) => t.id === candidate.id || !tilesCollide(t, candidate));
}

/** The first free spot (left-to-right, top-to-bottom scan). */
export function findFreeSpot(
  tiles: DeckTile[],
  w: number,
  h: number,
): { x: number; y: number } | null {
  for (let y = 0; y + h <= DECK_GRID_ROWS; y++) {
    for (let x = 0; x + w <= DECK_GRID_COLS; x++) {
      const cand: DeckTile = { id: "__cand__", widget: "__cand__", x, y, w, h };
      if (placementValid(tiles, cand)) return { x, y };
    }
  }
  return null;
}

/** Default layout (spec §3) — first open / "Standartga qaytarish". */
export const DEFAULT_TILES: DeckTile[] = [
  { id: "d-clock", widget: "clock", x: 0, y: 0, w: 3, h: 2 },
  { id: "d-score", widget: "score", x: 3, y: 0, w: 4, h: 2 },
  { id: "d-var", widget: "var", x: 7, y: 0, w: 2, h: 2 },
  { id: "d-extra", widget: "extra-time", x: 9, y: 0, w: 1, h: 1 },
  { id: "d-sponsor", widget: "auto-sponsor", x: 10, y: 0, w: 1, h: 1 },
  { id: "d-alloff", widget: "all-off", x: 11, y: 0, w: 1, h: 1 },
  { id: "d-ev-home", widget: "events:home", x: 0, y: 2, w: 3, h: 3 },
  { id: "d-ev-away", widget: "events:away", x: 3, y: 2, w: 3, h: 3 },
  { id: "d-ov-sb", widget: "overlay:scoreboard", x: 6, y: 2, w: 1, h: 1 },
  { id: "d-ov-big", widget: "overlay:big", x: 7, y: 2, w: 1, h: 1 },
  { id: "d-ov-mid", widget: "overlay:matchid", x: 8, y: 2, w: 1, h: 1 },
  { id: "d-ov-ball", widget: "overlay:little_stats_ball_control", x: 9, y: 2, w: 1, h: 1 },
];
